import { Box, Button, CircularProgress, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import styled from "styled-components";
import {
  NumberOrderIcon,
  OrderCalender,
} from "../../assets/Icon/OrderDetailIcon";
import NoDataFound from "../../components/common-components/NoDataFound";
import {
  getIncorporation,
  getItin,
  getMessageData,
  handleSendMessage,
  loadSelectedOrderFromStorage,
  setMessage,
  setNewMessage,
} from "../../stores/orders";
import { useAppDispatch } from "../../stores/store";
import { getUserData, localName } from "../../utils/StorageUtils";
import BackPageButton from "../../components/common-components/BackPageButton";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import OrderDetailTitleBar from "../../pages/orders/OrderDetailTitleBar";
import OrderDetailCard from "../../pages/orders/OrderDetailCard";
import MessageBox from "../../pages/orders/MessageBox";
import MessageEditor from "../../pages/orders/MessageEditor";
import TaxOrderDetailCard from "./TaxOrderDetailCard";
import TitleBar from "../common-components/TitleBar";
import CustomButton from "../common-components/CustomButton";
import { useNavigate } from "react-router-dom";
import { getTaxFilingData, getTaxFilingDataById } from "../../stores/taxfiling";
import { setToast } from "../../stores/toast/toastslice";

const TaxFillingDetailOrder = () => {
  const { id, orderId } = useParams<{ id: string; orderId: string }>();

  const userData = getUserData();
  const [isMessageBox, setIsMessageBox] = useState<boolean>(false);
  const [isMessageLoading, setIsMessageLoading] = useState(false);
  const messageEndRef = useRef<HTMLDivElement | null>(null);
  const [supportId, setSupportId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [countryCode, setCountryCode] = useState("");

  const [sentMessage, setSentMessage] = useState<string[]>([]);

  const dispatch = useAppDispatch();
  const getTaxFilingList = useCallback(async () => {
    if (!id) return;
    const payload = {
      tax_filing_file_id: id,
      order_id: orderId,
    };
    setIsLoading(true);
    await dispatch<any>(getTaxFilingDataById(payload)).then(
      async (res: any) => {
        if (res?.payload?.status >= 400) {
          await dispatch<any>(
            setToast({
              message:
                res?.payload?.data?.message ||
                (typeof res?.payload?.data?.message === "string" &&
                  res?.payload?.data?.message) ||
                "Something went wrong!",
              type: "error",
              title: "Error",
            }),
          );
          const timeout = setTimeout(() => {
            navigate("/tools/tax-filing/list");
          }, 2000);

          return () => clearTimeout(timeout);
        }
        setIsLoading(false);
      },
    );
  }, [dispatch, id]);
  useEffect(() => {
    getTaxFilingList();
  }, [getTaxFilingList]);
  useEffect(() => {
    dispatch<any>(loadSelectedOrderFromStorage());
  }, []);

  // const taxFilingDataReview = location.state?.taxFilingDataReview;
  // console.log(taxFilingDataReview,"taxFilingDataReview")
  const selectedOrder = useSelector((state: any) => state.orders.selectedOrder);
  // console.log("Selected Order ID:", selectedOrder?.orderId);
  // console.log("Selected Product ID:", selectedOrder?.productId);
  // console.log("Selected user ID:", selectedOrder?.userId);
  const userId = localStorage.getItem("userId") || selectedOrder?.userId;
  const [status, setStatus] = useState("");
  // console.log(taxFilingDataReview,"taxFilingDataReview");
  const {
    incorporationDetails,
    itinDetails,
    messageDetails,
    senderName,
    isMessageData,
    fetchMessageDeatil,
    fetchMessgaeData,
    typeMessage,
    selectedFile,
    messageStatus,
    orderDetailstatus,
  } = useSelector((state: any) => state.orders);
  const { taxFilingDataReview, reviewStatus } = useSelector(
    (state: any) => state.taxfiling,
  );
  // console.log(taxFilingDataReview,"taxFilingDataReview")

  const product_name =
    taxFilingDataReview?.tax_filing_file?.product_name || "Tax Filing";
  const orderItemId = orderId;
  // console.log(taxFilingDataReview?.tax_filing_files_list?.order_item_id,"ll")
  const reviewstatus = useSelector(
    (state: any) => state.taxfiling.reviewstatus,
  );
  // const location=useLocation();
  const step = taxFilingDataReview?.tax_filing_file?.step;
  const [hasUsCompany, setHasUsCompany] = useState<any>(
    itinDetails?.data?.has_us_company,
  );
  const navigate = useNavigate();
  console.log(step, "step");
  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; preview: string }[]
  >([]);

  const [data, setData] = useState<any>(null);

  const finalOrderId = orderItemId || orderId || "";

  useEffect(() => {
    if (selectedOrder) {
      refetchData();
    }
  }, [selectedOrder, dispatch, id]);

  useEffect(() => {});
  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
      document.getElementById("messgeContent")?.scrollTo({
        top: document.getElementById("messgeContent")?.scrollHeight,
        behavior: "smooth", // optional, for smooth scrolling
      });
    }
  }, [isMessageBox, fetchMessgaeData]);
  // const getTaxFilingList = async () => {
  //   // setLoading(true);
  //   const payload = {
  //     offset: 0,
  //     limit: 10,

  //   }
  //   const result = await dispatch<any>(getTaxFilingData(payload));
  //   // console.log(result?.payload?.tax_filing_files_list[0]?.product_name,"======result?.payload?.data");
  //  if(step === 2){
  //  // navigate(`/tools/tax-filing//tax-detail`);
  //  }

  //   // Check if taxFilingList has data, navigate to tax-filingList

  //   // setLoading(false);
  // }
  // useEffect(() => {
  //   getTaxFilingList();
  // }, []);

  useEffect(() => {
    if (selectedOrder?.productId === 1 && itinDetails) {
      setData(itinDetails);
      setStatus(itinDetails?.data?.status);
      setHasUsCompany(itinDetails?.data?.has_us_company);
    } else if (selectedOrder?.productId === 2 && incorporationDetails) {
      setData(incorporationDetails);
      setStatus(incorporationDetails?.data?.status);
      setCountryCode(incorporationDetails?.data?.country_code);
    }
  }, [itinDetails, incorporationDetails, selectedOrder]);

  const getMessage = async (showLoader: boolean = true) => {
    if (showLoader) {
      setIsMessageLoading(true);
    }
    try {
      const result = await dispatch<any>(
        getMessageData({ user_id: userId, order_id: orderItemId }),
      );

      if (showLoader) {
        setIsMessageLoading(false);
      }
    } catch (error) {
      // Optional: show error toast or handle error
    } finally {
      if (showLoader) {
        setIsMessageLoading(false);
      } // always stop loading
    }
  };

  useEffect(() => {
    if (userId && finalOrderId) {
      getMessage();
    }
  }, [userId]);

  const sendMessage = async () => {
    setIsLoading(true);
    const newMessage = typeMessage
      .replace(/<p><br\s*\/?><\/p>/gi, "")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (!newMessage && selectedFiles.length === 0) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("message", typeMessage || ""); // assuming message is a state variable
      // formData.append("sender_name", senderName);
      selectedFiles.forEach((fileObj: any, index: number) => {
        formData.append("files", fileObj.file);
      });
      const newdata = {
        message: typeMessage,
        sender_name: localName,
        files: selectedFiles.map((fileObj: any) => fileObj.file),
      };
      dispatch<any>(setNewMessage(newdata));

      const result = await dispatch<any>(
        handleSendMessage({
          user_id: userId,
          order_id: finalOrderId,
          formData,
        }),
      );

      setSentMessage((prev) => [...prev, typeMessage]);

      // getMessage(false);
      dispatch<any>(setMessage(""));
      setSelectedFiles([]);
      setSentMessage([]);
      setSupportId(result.payload.data.id);
      if (result.payload.status == 1) {
        setIsMessageBox(true);
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  // console.log(taxFilingDataReview,"taxFilingDataReviewrrr")

  const formatFields = (fileData: any) => {
    if (!fileData) return [];

    const fillingType = taxFilingDataReview?.tax_filing_file?.filling_type;
    const haveMultimembers =
      taxFilingDataReview?.tax_filing_file?.have_multimembers;

    // Common fields for all types
    const commonFields = [
      {
        title: "Name and Surname",
        value: fileData.name_surname || "",
        key: "name_surname",
        border: true,
        attribute: "name_surname",
      },
      {
        title: "E-Mail",
        value: fileData.email || "",
        key: "email",
        border: true,
        attribute: "email",
      },
      {
        title: "Date of Birth",
        value: fileData.date_of_birth || "",
        key: "date_of_birth",
        border: true,
        attribute: "date_of_birth",
      },
      {
        title: "Country",
        value: fileData.country || "",
        key: "country",
        border: true,
        attribute: "country",
      },
      {
        title: "Business Address",
        value: fileData.business_address || "",
        key: "business_address",
        border: true,
        attribute: "business_address",
      },
      {
        title: "Nature of Business",
        value: fileData.nature_of_business || "",
        key: "nature_of_business",
        border: true,
        attribute: "nature_of_business",
      },
    ];

    // Phone field - different for different types
    const phoneField =
      fillingType === "llc" && haveMultimembers
        ? {
            title: "Phone",
            value: fileData.country_code + fileData.phone_number || "",
            key: "phone_number",
            border: true,
            attribute: "phone_number",
          }
        : {
            title: "Phone",
            value: fileData.country_code + fileData.phone_number || "",
            key: "phone_number",
            border: true,
            attribute: "phone_number",
          };

    // Working options - only for Single Member LLC
    const workingFields =
      fillingType === "llc" && !haveMultimembers
        ? [
            {
              title: "Bussiness Details(option1)",
              value: fileData.working_outside_us ? "Yes" : "No",
              key: "working_outside_us",
              border: true,
              attribute: "working_outside_us",
            },
            {
              title: "Bussiness Details(option2)",
              value: fileData.working_within_us ? "Yes" : "No",
              key: "working_within_us",
              border: true,
              attribute: "working_within_us",
            },
          ]
        : [];

    // Multi-member specific fields
    const multiMemberFields =
      fillingType === "llc" && haveMultimembers
        ? [
            // {
            //   title: "US Address",
            //   value: fileData.us_address || "",
            //   key: "us_address",
            //   border: true,
            //   attribute: "us_address"
            // },
            // {
            //   title: "Foreign Address",
            //   value: fileData.foreign_address || "",
            //   key: "foreign_address",
            //   border: true,
            //   attribute: "foreign_address"
            // },
            {
              title: "Additional Members",
              value: fileData.additional_members || "",
              key: "additional_members",
              border: true,
              attribute: "additional_members",
            },
            {
              title: "Partnership Structure",
              value: fileData.partnership_structure || "",
              key: "partnership_structure",
              border: true,
              attribute: "partnership_structure",
            },
          ]
        : [];

    // Business Income fields - different field names for different types
    const businessIncomeFields = [
      {
        title: "Gross Income (USD)",
        value: fileData.gross_income ? `$${fileData.gross_income}` : "",
        key: "gross_income",
        border: true,
        attribute: "gross_income",
      },
      {
        title: "Amount of Returns (USD)",
        value:
          fileData.amount_of_returns || fileData.amount_returns
            ? `$${fileData.amount_of_returns || fileData.amount_returns}`
            : "",
        key: "amount_of_returns",
        border: true,
        attribute: "amount_of_returns",
      },
      {
        title: "Cost of Goods Sold (USD)",
        value: fileData.cost_of_goods_sold
          ? `$${fileData.cost_of_goods_sold}`
          : "",
        key: "cost_of_goods_sold",
        border: true,
        attribute: "cost_of_goods_sold",
      },
    ];

    // Business Expenses - common for all types
    const businessExpenseFields = [
      {
        title: "Advertising (USD)",
        value: fileData.advertising ? `$${fileData.advertising}` : "-",
        key: "advertising",
        border: true,
        attribute: "advertising",
      },
      {
        title: "Commissions and Fees (USD)",
        value: fileData.commissions_fees
          ? `$${fileData.commissions_fees}`
          : "-",
        key: "commissions_fees",
        border: true,
        attribute: "commissions_fees",
      },
      {
        title: "Contract Labor (USD)",
        value: fileData.contract_labor ? `$${fileData.contract_labor}` : "-",
        key: "contract_labor",
        border: true,
        attribute: "contract_labor",
      },
      {
        title: "Insurance (other than health) (USD)",
        value: fileData.insurance ? `$${fileData.insurance}` : "-",
        key: "insurance",
        border: true,
        attribute: "insurance",
      },
      {
        title: "Interest paid to banks (USD)",
        value: fileData.interest_bank ? `$${fileData.interest_bank}` : "-",
        key: "interest_bank",
        border: true,
        attribute: "interest_bank",
      },
      {
        title: "Legal and Professional Services (USD)",
        value: fileData.legal_professional
          ? `$${fileData.legal_professional}`
          : "-",
        key: "legal_professional",
        border: true,
        attribute: "legal_professional",
      },
      {
        title: "Office Expenses (USD)",
        value: fileData.office_expenses ? `$${fileData.office_expenses}` : "-",
        key: "office_expenses",
        border: true,
        attribute: "office_expenses",
      },
      {
        title: "Pension and Profit Sharing (USD)",
        value: fileData.pension_profit_sharing
          ? `$${fileData.pension_profit_sharing}`
          : "-",
        key: "pension_profit_sharing",
        border: true,
        attribute: "pension_profit_sharing",
      },
      {
        title: "Rent or Lease: Vehicles, Machinery and equipment (USD)",
        value: fileData.rent_lease_vehicles
          ? `$${fileData.rent_lease_vehicles}`
          : "-",
        key: "rent_lease_vehicles",
        border: true,
        attribute: "rent_lease_vehicles",
      },
      {
        title: "Repairs and Maintenance (USD)",
        value: fileData.repairs_maintenance
          ? `$${fileData.repairs_maintenance}`
          : "-",
        key: "repairs_maintenance",
        border: true,
        attribute: "repairs_maintenance",
      },
      // {
      //   title: "Supplies Materials (USD)",
      //   value: fileData.supplies_materials ? `$${fileData.supplies_materials}` : "-",
      //   key: "supplies_materials",
      //   border: true,
      //   attribute: "supplies_materials"
      // },
      {
        title: "Supplies (technology/software) (USD)",
        value: fileData.supplies_materials
          ? `$${fileData.supplies_materials}`
          : "-",
        key: "supplies_technology",
        border: true,
        attribute: "supplies_technology",
      },
      // {
      //   title: "Supplies Stationary (USD)",
      //   value: fileData.supplies_stationary ? `$${fileData.supplies_stationary}` : "-",
      //   key: "supplies_stationary",
      //   border: true,
      //   attribute: "supplies_stationary"
      // },
      {
        title: "Supplies (furniture) (USD)",
        value: fileData.supplies_stationary
          ? `$${fileData.supplies_stationary}`
          : "-",
        key: "supplies_furniture",
        border: true,
        attribute: "supplies_furniture",
      },
      {
        title: "Taxes and Licenses (USD)",
        value: fileData.taxes_licenses ? `$${fileData.taxes_licenses}` : "-",
        key: "taxes_licenses",
        border: true,
        attribute: "taxes_licenses",
      },
      {
        title: "Travel and Meals (50% countable) (USD)",
        value: fileData.travel_meals ? `$${fileData.travel_meals}` : "-",
        key: "travel_meals",
        border: true,
        attribute: "travel_meals",
      },
      {
        title: "Utilities (USD)",
        value: fileData.utilities ? `$${fileData.utilities}` : "-",
        key: "utilities",
        border: true,
        attribute: "utilities",
      },
      {
        title: "Wages (USD)",
        value: fileData.wages ? `$${fileData.wages}` : "-",
        key: "wages",
        border: true,
        attribute: "wages",
      },
      {
        title: "Other Business Expenses (USD)",
        value: fileData.other_business ? `$${fileData.other_business}` : "-",
        key: "other_business",
        border: true,
        attribute: "other_business",
      },
    ];

    // Personal Income fields - common for all types
    const personalIncomeFields = [
      {
        title: "Personal Gross Income (USD)",
        value: fileData.gross_income ? `$${fileData.gross_income}` : "-",
        key: "personal_gross_income",
        border: true,
        attribute: "personal_gross_income",
      },
      {
        title: "TaxableInterest Income (USD)",
        value: fileData.interest_income ? `$${fileData.interest_income}` : "-",
        key: "interest_income",
        border: true,
        attribute: "interest_income",
      },
      {
        title: "Tax-exempt Interest Income (USD)",
        value: fileData.tax_exempt_interest
          ? `$${fileData.tax_exempt_interest}`
          : "-",
        key: "tax_exempt_interest",
        border: true,
        attribute: "tax_exempt_interest",
      },
      {
        title: "Qualified Dividends Income (USD)",
        value: fileData.qualified_dividends
          ? `$${fileData.qualified_dividends}`
          : "-",
        key: "qualified_dividends",
        border: true,
        attribute: "qualified_dividends",
      },
      {
        title: "Taxable Refunds (USD)",
        value: fileData.taxable_refunds ? `$${fileData.taxable_refunds}` : "-",
        key: "taxable_refunds",
        border: true,
        attribute: "taxable_refunds",
      },
      {
        title: "Scholarship and Fellowship Grants (USD)",
        value: fileData.scholarship_fellowship_grants
          ? `$${fileData.scholarship_fellowship_grants}`
          : "N/A",
        key: "scholarship_fellowship_grants",
        border: true,
        attribute: "scholarship_fellowship_grants",
      },
      {
        title: "Capital Gain or (Loss) (USD)",
        value: fileData.capital_gain_loss
          ? `$${fileData.capital_gain_loss}`
          : "-",
        key: "capital_gain_loss",
        border: true,
        attribute: "capital_gain_loss",
      },
      {
        title: "Other Gains or (Losses) (USD)",
        value: fileData.other_gains_losses
          ? `$${fileData.other_gains_losses}`
          : "-",
        key: "other_gains_losses",
        border: true,
        attribute: "other_gains_losses",
      },
      {
        title: "IRA Distributions Pensions and Annuities (USD)",
        value: fileData.ira_distributions
          ? `$${fileData.ira_distributions}`
          : "-",
        key: "ira_distributions",
        border: true,
        attribute: "ira_distributions",
      },
      // {
      //   title: "Pensions and Annuities (USD)",
      //   value: fileData.pensions_annuities ? `$${fileData.pensions_annuities}` : "-",
      //   key: "pensions_annuities",
      //   border: true,
      //   attribute: "pensions_annuities"
      // },
      {
        title: "Farm Income or (Loss) (USD)",
        value: fileData.farm_income_loss
          ? `$${fileData.farm_income_loss}`
          : "-",
        key: "farm_income_loss",
        border: true,
        attribute: "farm_income_loss",
      },
      {
        title: "Unemployment Compensation (USD)",
        value: fileData.unemployment_compensation
          ? `$${fileData.unemployment_compensation}`
          : "-",
        key: "unemployment_compensation",
        border: true,
        attribute: "unemployment_compensation",
      },
      {
        title: "Other Income (USD)",
        value: fileData.other_income ? `$${fileData.other_income}` : "-",
        key: "other_income",
        border: true,
        attribute: "other_income",
      },
    ];

    // Multi-member specific personal income field
    const multiMemberPersonalIncomeField =
      fillingType === "llc" &&
      haveMultimembers &&
      fileData.personal_gross_income
        ? [
            {
              title: "Personal Gross Income (USD)",
              value: fileData.personal_gross_income
                ? `$${fileData.personal_gross_income}`
                : "-",
              key: "personal_gross_income",
              border: true,
              attribute: "personal_gross_income",
            },
          ]
        : [];

    // Multi-member specific scholarship field
    const scholarshipField =
      fillingType === "llc" &&
      haveMultimembers &&
      fileData.scholarship_fellowship_grants
        ? [
            {
              title: "Scholarship/Fellowship/Grants (USD)",
              value: fileData.scholarship_fellowship_grants
                ? `$${fileData.scholarship_fellowship_grants}`
                : "-",
              key: "scholarship_fellowship_grants",
              border: true,
              attribute: "scholarship_fellowship_grants",
            },
          ]
        : [];

    // Contributions and Distributions - only for Single Member LLC
    const contributionsFields =
      fillingType === "llc" && !haveMultimembers
        ? [
            {
              title: "Total Contributions (USD)",
              value: fileData.total_contributions
                ? `$${fileData.total_contributions}`
                : "-",
              key: "total_contributions",
              border: true,
              attribute: "total_contributions",
            },
            {
              title: "Total Distributions (USD)",
              value: fileData.total_distributions
                ? `$${fileData.total_distributions}`
                : "-",
              key: "total_distributions",
              border: false,
              attribute: "total_distributions",
            },
          ]
        : [];
    // console.log(taxFilingDataReview?.tax_filing_file?.passport,"taxFilingDataReview")
    // Documents section
    const documentsFields = [
      {
        title: "Company Documents",
        value: taxFilingDataReview?.documents_by_type?.company || [],
        key: "company_documents",
        border: true,
        attribute: "company_documents",
        hasDocument: true,
      },
      {
        title: "EIN Documents",
        value: taxFilingDataReview?.documents_by_type?.ein || [],
        key: "ein_document",
        border: true,
        attribute: "ein_document",
        hasDocument: true,
      },
      {
        title: "Passport Scan",
        value: taxFilingDataReview?.tax_filing_file?.passport || null,
        key: "passport_scan",
        border: true,
        attribute: "passport_scan",
        hasDocument: true,
      },
      {
        title: "ITIN Documents",
        value: taxFilingDataReview?.documents_by_type?.itin || [],
        key: "itin_document",
        border: false,
        attribute: "itin_document",
        hasDocument: true,
      },
    ];

    // Combine all fields based on type
    const allFields = [
      ...commonFields,
      phoneField,
      ...workingFields,
      ...multiMemberFields,
      ...businessIncomeFields,
      ...businessExpenseFields,
      ...personalIncomeFields,
      ...multiMemberPersonalIncomeField,
      ...scholarshipField,
      ...contributionsFields,
      ...documentsFields,
    ];

    return allFields;
  };
  // console.log(taxFilingDataReview?.documents_by_type?.company[0],"yy")
  // } else if (selectedOrder?.productId === 1) {
  //   rawFields = [
  //     { key: "first_name", title: "First Name" },
  //     { key: "last_name", title: "Last Name" },
  //     { key: "business_incorporation", title: "Business Incorporation" },
  //     { key: "ein_document", title: "EIN Document" },
  //     { key: "w7_form", title: "W7 Form" },
  //     { key: "w7_signed_form", title: "W7 Signed Form" },
  //     { key: "scan_passport", title: "Scanned Passport" },
  //     { key: "form_2848", title: "Form 2848" },
  //     { key: "form_2848_signed_form", title: "Form 2848 Signed Form" },
  //     // { key: "verified_form_files", title: "ITIN Verified Document" },
  //   ];
  // }

  //   const expandedFields = rawFields.flatMap((field) => {
  //     const value = details?.[field.key];

  //     if (field.key === "llc_document_file") {
  //       const hasVerified =
  //         Array.isArray(details?.llc_verified_documents) &&
  //         details.llc_verified_documents.length > 0;

  //       return {
  //         title: hasVerified ? "Company Formation Document 1" : "Company Formation Document",
  //         value,
  //         key: field.key,
  //         attribute: field.key
  //       };
  //     }

  //     // Handle array fields and expand them
  //     if (Array.isArray(value)) {
  //       return value.map((item, idx) => ({
  //         title: `${field.title} ${idx + 2}`,
  //         value: item,
  //         key: `${field.key}_${idx}`,
  //         attribute: field.key
  //       }));
  //     }

  //     // Skip empty non-array values
  //     if (!value) return [];

  //     return {
  //       title: field.title,
  //       value,
  //       key: field.key,
  //       attribute: field.key
  //     };
  //   });

  //   return expandedFields.map((item, index) => ({
  //     ...item,
  //     border: index !== expandedFields.length - 1,
  //   }));
  // };

  const orderBasicDetail = [
    {
      title: "Number",
      value:
        taxFilingDataReview?.tax_filing_file?.id?.toString() ||
        orderItemId ||
        "N/A",
      key: "id",
      border: true,
      attribute: "id",
    },
    {
      title: "Created",
      value: taxFilingDataReview?.tax_filing_file?.created_at
        ? new Date(
            taxFilingDataReview?.tax_filing_file.created_at,
          ).toLocaleDateString()
        : "N/A",
      key: "created_at",
      border: true,
      attribute: "created_at",
    },
    {
      title: "Service",
      value: product_name,
      key: "product_name",
      border: true,
      attribute: "product_name",
    },
    {
      title: "Started",
      value: taxFilingDataReview?.tax_filing_file?.created_at
        ? new Date(
            taxFilingDataReview?.tax_filing_file.created_at,
          ).toLocaleDateString()
        : "N/A",
      key: "related_orders",
      border: true,
      attribute: "related_orders",
      itemLeft: true,
    },
    {
      title: "Completed",
      value: taxFilingDataReview?.tax_filing_file?.updated_at
        ? new Date(
            taxFilingDataReview?.tax_filing_file.updated_at,
          ).toLocaleDateString()
        : "--",
      key: "completed_at",
      border: false,
      attribute: "completed_at",
      itemLeft: true,
    },
  ];

  // const filteredItems = items
  //   .map((item) => ({
  //     title: item.title,
  //     value: details?.[item.key] ?? "",
  //     icon: item.icon,
  //   }))
  //   .filter((item) => item.value);

  // return filteredItems.map((item, index) => ({
  //   ...item,
  //   border: index !== filteredItems.length - 1,
  // }));

  const clientBasicDetail = (details: any) => {
    return [
      {
        key: "user_name",
        title: "Users",
      },
    ]
      .map((item) => ({
        title: item.title,
        value: details?.[item.key] ?? "",
        border: false,
      }))
      .filter((item) => item.value);
  };

  const refetchData = async () => {
    if (selectedOrder?.productId === 1) {
      await dispatch<any>(getItin({ order_id: id }));
    } else if (selectedOrder?.productId === 2) {
      await dispatch<any>(getIncorporation({ order_id: id }));
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <StyledBox>
      <BackPageButton title="Orders" />
      {/* <OrderDetailTitleBar
        title={
         " Multi-Member LLC Tax Filing Form"
        }
        status={status ? status : ''}
        productId={selectedOrder?.productId}
        onSuccessUpload={refetchData}
        loading={orderDetailstatus === "loading"}
      /> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <TitleBar title={product_name} />
        <StyledStatusButton>
          <StatusText>Submitted</StatusText>
        </StyledStatusButton>
      </Box>

      <Box
        sx={{
          borderBottom: "2px solid #EAF1FA",
          mb: 2,
          position: "relative",
          paddingY: "20px",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: "#2977CC",
            fontWeight: 600,
            fontSize: "20px",
            borderBottom: "2px solid #2977CC",
            display: "inline-block",
            pb: 0.5,
            position: "absolute",
            bottom: "-2px",
          }}
        >
          Details
          {/* Project Data */}
        </Typography>
      </Box>
      {/* Grid Conatiner To show Detail */}
      <Grid container spacing={2}>
        <StyledGridBox
          size={{ xs: 12, md: 8 }}
          sx={{
            border: "2px solid #EAF1FA",
            borderRadius: "12px",
            padding: "20px",
          }}
        >
          <Box sx={{ padding: 2 }}>
            {reviewstatus == "loading" ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                  width: "100%",
                  border: "1px solid #EAF1FA",
                  borderRadius: "12px",
                  backgroundColor: "#FFF",
                }}
              >
                <ListLoadingNew />
              </Box>
            ) : taxFilingDataReview?.tax_filing_file?.file_data &&
              reviewstatus != "loading" ? (
              <TaxOrderDetailCard
                orderFormData={formatFields(
                  taxFilingDataReview?.tax_filing_file?.file_data,
                )}
                isViewButton={true}
                cardTitle="Form Fields"
                countryCode={countryCode}
                hasUsCompany={hasUsCompany}
                hasItinDocument={true}
                hasEINDocument={
                  taxFilingDataReview?.documents_by_type?.ein?.length > 0
                }
                data={taxFilingDataReview?.tax_filing_file}
                // loading={false}
              />
            ) : // {/* Document Categories Section */}

            reviewstatus == "loading" &&
              !taxFilingDataReview?.tax_filing_file?.file_data ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                  width: "100%",
                  border: "1px solid #EAF1FA",
                  borderRadius: "12px",
                  backgroundColor: "#FFF",
                }}
              >
                <NoOrdersFound title="No Data Found" />
              </Box>
            ) : null}
          </Box>
          <Grid size={{ xs: 12, md: 12 }} sx={{ paddingY: "20px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#2977CC",
                fontWeight: 600,
                fontSize: "22px",
                borderBottom: "2px solid #2977CC",
                display: "inline-block",
                pb: 0.5,
                marginX: 2,
              }}
            >
              Message
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            {isMessageLoading ? (
              <Box>
                <ListLoadingNew isStart={true} />
              </Box>
            ) : fetchMessgaeData.length == 0 &&
              !isMessageLoading &&
              !isMessageBox ? (
              <Box ref={messageEndRef}>
                <NoDataFound
                  isMessage={true}
                  title="No Conversation Yet"
                  subTitle="No conversation has been initiated yet. Once a message is sent or received, the conversation history will appear here."
                  handleData={() => {
                    getMessage(false);
                    setIsMessageBox(true);
                  }}
                  status={taxFilingDataReview?.tax_filing_file?.step >= 2}
                />
              </Box>
            ) : isMessageData && isMessageBox ? (
              <>
                <Grid
                  size={{ xs: 12, md: 12 }}
                  sx={{ padding: 2 }}
                  ref={messageEndRef}
                >
                  <Box ref={messageEndRef}>
                    <MessageBox
                      fetchMessgaeData={fetchMessgaeData}
                      sentData={messageDetails}
                      sending={isLoading}
                    />
                  </Box>
                  <Box>
                    <MessageEditor
                      handleSend={() => {
                        sendMessage();
                      }}
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      isMessageBox={setIsMessageBox}
                    />
                  </Box>
                </Grid>
              </>
            ) : (
              <Box ref={messageEndRef}>
                <MessageBox
                  fetchMessgaeData={fetchMessgaeData}
                  sentData={messageDetails}
                  sending={isLoading}
                />
                <Grid
                  size={{ xs: 12, md: 12 }}
                  sx={{ borderBottom: "2px solid #EAF1FA", padding: 2 }}
                  ref={messageEndRef}
                >
                  {isMessageBox ? (
                    <MessageEditor
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      handleSend={sendMessage}
                      isMessageBox={setIsMessageBox}
                    />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        type="submit"
                        sx={{
                          width: "120px",
                          fontSize: "13.3px",
                          fontWeight: 600,
                          color: "#fff",
                          background:
                            "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
                        }}
                        onClick={() => setIsMessageBox(true)}
                      >
                        Reply
                      </Button>
                    </Box>
                  )}
                </Grid>
              </Box>
            )}
          </Grid>
        </StyledGridBox>

        <Grid size={{ xs: 12, md: 4 }}>
          {/* {orderDetailstatus === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <ListLoadingNew />
            </Box>
          ) : data?.data &&
            orderDetailstatus != "loading" &&
            orderBasicDetail(data?.order).length > 0 ? ( */}
          <TaxOrderDetailCard
            orderFormData={orderBasicDetail}
            isClassName={true}
            cardTitle="Details"
          />
          {/* ) : orderDetailstatus != "loading" &&
            orderBasicDetail(data?.order).length > 0 ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <NoOrdersFound title="No Data Found" showImage={false} />
            </Box>
          ) : null} */}
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default TaxFillingDetailOrder;
interface OrderTitleProps {
  isClassName?: boolean;
}
export const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  padding: "16px",
});
export const StyledGridBox = styled(Grid)(({ theme }) => ({
  border: "2px solid #EAF1FA",
  borderRadius: "12px",
  // padding: "10px",
}));
export const OrderTitle = styled(Typography)<OrderTitleProps>(
  ({ isClassName }) => ({
    fontSize: "19px !important",
    color: "#01060B",
    paddingTop: isClassName ? "10px" : "20px",
    paddingBottom: "10px",
  }),
);
export const StyledGridBoxChild = styled(Grid)(({ theme }) => ({
  border: "1px solid #EAF1FA",
  borderRadius: "8px",
  padding: "20px",
}));
export const FormTItle = styled(Typography)({
  fontSize: "14px !important",
  color: "#6C6F71",
  fontWeight: 500,
});
export const FormTItleValue = styled(Typography)({
  width: "50%",
  fontSize: "14px !important",
  color: "#01060B",
  fontWeight: 500,
  display: "flex",
  // alignItems: "center",
});
// minWidth: "113px",
// width: "auto",

// textAlign: "center",
// display: "inline-block",
// padding: "9px",
// // paddingx: "9px",
// borderRadius: "6px",
// fonsize: "12px",
// fontWeight: "600",
export const StyledStatusButton = styled(Box)({
  cursor: "pointer",
  backgroundColor: "#EAF1FA",
  borderRadius: "6px",
  padding: "9px",
  display: "inline-block",
  marginTop: "10px",
});
export const StatusText = styled(Typography)({
  // backgroundColor: "#2977CC", // Blue background
  color: "#2977CC", // White text
  borderRadius: "12px",
  padding: "4px 12px",
  fontSize: "14px",
  fontWeight: 700,
  textAlign: "center",
  display: "inline-block",
});

export const DocumentCategory = styled(Box)({
  marginBottom: "16px",
});

export const CategoryLabel = styled(Typography)({
  fontSize: "14px",
  color: "#6C6F71",
  fontWeight: 500,
  marginBottom: "8px",
});

export const DocumentLink = styled(Typography)({
  fontSize: "14px",
  color: "#2977CC",
  fontWeight: 400,
  cursor: "pointer",
  marginBottom: "4px",
  "&:hover": {
    textDecoration: "underline",
  },
});
